import { useQuery } from '@tanstack/react-query';
import dataService from 'services/dataService';
import { useEffect } from 'react';

import { apiUrlGenerator } from '../use-api';
import { showResult } from '../utils';

const queryFn = async () => {
  const url = 'core-2/patients/sms-campaign/question-keys';
  const { data, error } = await dataService.getList<string[]>(
    apiUrlGenerator(url),
  );

  if (error) {
    return Promise.reject(error);
  }

  return data;
};

export const useGetCampaignQuestionKeys = () => {
  const { data, isLoading, error } = useQuery<
    string[] | undefined,
    string | undefined
  >({
    queryKey: ['getSmsCampaignQuestionKeys'],
    queryFn,
  });

  useEffect(() => {
    if (error) {
      showResult(error);
    }
  }, [error]);

  return { data, isLoading };
};
